import { Component, OnDestroy, OnInit } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { CmsComponentData, ICON_TYPE } from '@spartacus/storefront'
import { Subscription } from 'rxjs'

@Component({
  selector: 'app-custom-announcement-banner',
  templateUrl: './custom-announcement-banner.component.html',
  styleUrl: './custom-announcement-banner.component.scss',
  standalone: false
})
export class CustomAnnouncementBannerComponent implements OnInit, OnDestroy {
  public isVisible = true
  public iconTypes = ICON_TYPE
  private subscription = new Subscription()

  constructor(
    public component: CmsComponentData<any>,
    private sanitizer: DomSanitizer
  ) {}

  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }

  ngOnInit(): void {
    this.subscription.add(
      this.component.data$.subscribe((res) => {
        const isClosed = sessionStorage.getItem(res.uid) === 'true'
        this.isVisible = !isClosed
      })
    )
  }

  hideBanner(uid: string): void {
    this.isVisible = false
    sessionStorage.setItem(uid, 'true')
  }

  public bypassSecurityTrustHtml(html: string = ''): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html)
  }
}
